import styled from 'styled-components'
import { Button } from '@components/Button'

export const NameForm = styled.form`
	display: flex;
	flex-direction: column;
`

export const NameFields = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`

/** At `lg` it keeps the Join panel's rhythm: its other full-width buttons sit 34px under what precedes them. */
export const ContinueButton = styled(Button)`
	margin-top: ${({ size }) => (size === 'lg' ? '34px' : '28px')};
	width: 100%;
`
